import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'

import Home from './pages/home'
import Error from './pages/error'
import Branches from './pages/branches'
import Router from './components/router'
import Employers from './pages/employers'
import AdditionalData from './pages/AdditionalData'
import Staff from './pages/staff'
import Students from './pages/students'

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<Router />}>
          <Route index element={<Home />} />
          <Route path='/:language' element={<Home />} />
          <Route path='/:language/employers' element={<Employers />} />
          <Route path='/:language/branches' element={<Branches />} />
          <Route path='/:language/additional' element={<AdditionalData />} />
          <Route path='/:language/staff' element={<Staff />} />
          <Route path='/:language/students' element={<Students />} />
          <Route path='/branches' element={<Branches />} />
          <Route path='/employers' element={<Employers />} />
          <Route path='/additional' element={<AdditionalData />} />
          <Route path='/students' element={<Students />} />
          <Route path='/staff' element={<Staff />} />
          <Route path='*' element={<Error />} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}
export default App
